var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChevrons(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 3759.074,
    height: 97.529,
    viewBox: "0 0 3759.074 97.529",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Chevrons",
    transform: "translate(1197 -310.288)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_74",
    "data-name": "Group 74",
    transform: "translate(-1197 310.288)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M1981.716,0l48.9,48.9-48.628,48.628h34.638l48.166-48.166L2015.429,0Z",
    transform: "translate(-352.644)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M1887.349,0l48.9,48.9-48.628,48.628h34.637l48.166-48.166L1921.062,0Z",
    transform: "translate(-335.852)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M1698.614,0l48.9,48.9-48.628,48.628h34.638l48.166-48.166L1732.327,0Z",
    transform: "translate(-302.267)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M1509.879,0l48.9,48.9-48.627,48.628h34.636l48.166-48.166L1543.592,0Z",
    transform: "translate(-268.681)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M1321.144,0l48.9,48.9-48.628,48.628h34.637l48.166-48.166L1354.857,0Z",
    transform: "translate(-235.096)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M1132.41,0l48.9,48.9-48.628,48.628h34.637l48.166-48.166L1166.123,0Z",
    transform: "translate(-201.511)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M943.674,0l48.9,48.9L943.946,97.528h34.637l48.166-48.166L977.388,0Z",
    transform: "translate(-167.926)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M754.94,0l48.9,48.9L755.212,97.528h34.637l48.166-48.166L788.653,0Z",
    transform: "translate(-134.341)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M660.572,0l48.9,48.9L660.844,97.528h34.637l48.166-48.166L694.285,0Z",
    transform: "translate(-117.548)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M566.2,0l48.9,48.9L566.477,97.528h34.636L649.28,49.362,599.918,0Z",
    transform: "translate(-100.755)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M1792.982,0l48.9,48.9-48.628,48.628h34.637l48.166-48.166L1826.695,0Z",
    transform: "translate(-319.059)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M471.838,0l48.9,48.9L472.11,97.528h34.637l48.166-48.166L505.551,0Z",
    transform: "translate(-83.963)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M1604.247,0l48.9,48.9-48.628,48.628h34.637l48.166-48.166L1637.96,0Z",
    transform: "translate(-285.474)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M377.47,0l48.9,48.9L377.742,97.528h34.637l48.166-48.166L411.183,0Z",
    transform: "translate(-67.17)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M1415.512,0l48.9,48.9-48.627,48.628h34.637l48.166-48.166L1449.225,0Z",
    transform: "translate(-251.889)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M283.1,0,332,48.9,283.374,97.528h34.637l48.166-48.166L316.815,0Z",
    transform: "translate(-50.378)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M1226.776,0l48.9,48.9-48.628,48.628h34.638l48.166-48.166L1260.49,0Z",
    transform: "translate(-218.303)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M188.734,0l48.9,48.9L189.007,97.528h34.637L271.81,49.362,222.448,0Z",
    transform: "translate(-33.585)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M1038.042,0l48.9,48.9-48.627,48.628h34.638l48.166-48.166L1071.755,0Z",
    transform: "translate(-184.718)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M94.368,0l48.9,48.9L94.64,97.528h34.637l48.166-48.166L128.081,0Z",
    transform: "translate(-16.793)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M849.307,0l48.9,48.9L849.579,97.528h34.636l48.166-48.166L883.021,0Z",
    transform: "translate(-151.133)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M0,0,48.9,48.9.272,97.528H34.91L83.076,49.362,33.713,0Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_82",
    "data-name": "Group 82",
    transform: "translate(849.926 310.288)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5-2",
    "data-name": "Path 5",
    d: "M2064.792,0l-48.9,48.9,48.628,48.628h-34.638l-48.166-48.166L2031.079,0Z",
    transform: "translate(-1981.716 0.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6-2",
    "data-name": "Path 6",
    d: "M1970.424,0l-48.9,48.9,48.628,48.628h-34.637l-48.166-48.166L1936.711,0Z",
    transform: "translate(-1809.774 0.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7-2",
    "data-name": "Path 7",
    d: "M1781.69,0l-48.9,48.9,48.628,48.628H1746.78l-48.166-48.166L1747.977,0Z",
    transform: "translate(-1465.89 0.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8-2",
    "data-name": "Path 8",
    d: "M1592.954,0l-48.9,48.9,48.627,48.628h-34.636l-48.166-48.166L1559.241,0Z",
    transform: "translate(-1122.004 0.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9-2",
    "data-name": "Path 9",
    d: "M1404.22,0l-48.9,48.9,48.628,48.628h-34.637l-48.166-48.166L1370.507,0Z",
    transform: "translate(-778.12 0.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10-2",
    "data-name": "Path 10",
    d: "M1215.484,0l-48.9,48.9,48.628,48.628h-34.637L1132.41,49.362,1181.771,0Z",
    transform: "translate(-434.235 0.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11-2",
    "data-name": "Path 11",
    d: "M1026.75,0l-48.9,48.9,48.628,48.628H991.841L943.674,49.362,993.037,0Z",
    transform: "translate(-90.351 0.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12-2",
    "data-name": "Path 12",
    d: "M838.015,0l-48.9,48.9,48.628,48.628H803.106L754.94,49.362,804.3,0Z",
    transform: "translate(253.534 0.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13-2",
    "data-name": "Path 13",
    d: "M743.648,0l-48.9,48.9,48.628,48.628H708.739L660.572,49.362,709.935,0Z",
    transform: "translate(425.476 0.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14-2",
    "data-name": "Path 14",
    d: "M649.28,0l-48.9,48.9,48.628,48.628H614.371L566.2,49.362,615.567,0Z",
    transform: "translate(597.419 0.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15-2",
    "data-name": "Path 15",
    d: "M1876.057,0l-48.9,48.9,48.628,48.628h-34.637l-48.166-48.166L1842.344,0Z",
    transform: "translate(-1637.832 0.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16-2",
    "data-name": "Path 16",
    d: "M554.912,0l-48.9,48.9L554.64,97.528H520L471.838,49.362,521.2,0Z",
    transform: "translate(769.361 0.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17-2",
    "data-name": "Path 17",
    d: "M1687.322,0l-48.9,48.9,48.628,48.628h-34.637l-48.166-48.166L1653.609,0Z",
    transform: "translate(-1293.947 0.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18-2",
    "data-name": "Path 18",
    d: "M460.546,0l-48.9,48.9,48.628,48.628H425.636L377.47,49.362,426.832,0Z",
    transform: "translate(941.303 0.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19-2",
    "data-name": "Path 19",
    d: "M1498.587,0l-48.9,48.9,48.627,48.628h-34.637l-48.166-48.166L1464.874,0Z",
    transform: "translate(-950.062 0.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20-2",
    "data-name": "Path 20",
    d: "M366.178,0l-48.9,48.9,48.628,48.628H331.269L283.1,49.362,332.465,0Z",
    transform: "translate(1113.245 0.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21-2",
    "data-name": "Path 21",
    d: "M1309.852,0l-48.9,48.9,48.628,48.628h-34.638l-48.166-48.166L1276.139,0Z",
    transform: "translate(-606.177 0.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22-2",
    "data-name": "Path 22",
    d: "M271.81,0l-48.9,48.9,48.628,48.628H236.9L188.734,49.362,238.1,0Z",
    transform: "translate(1285.188 0.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23-2",
    "data-name": "Path 23",
    d: "M1121.118,0l-48.9,48.9,48.627,48.628h-34.638l-48.166-48.166L1087.4,0Z",
    transform: "translate(-262.294 0.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24-2",
    "data-name": "Path 24",
    d: "M177.443,0l-48.9,48.9L177.17,97.528H142.533L94.368,49.362,143.729,0Z",
    transform: "translate(1457.13 0.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25-2",
    "data-name": "Path 25",
    d: "M932.382,0l-48.9,48.9,48.628,48.628H897.473L849.307,49.362,898.668,0Z",
    transform: "translate(81.592 0.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26-2",
    "data-name": "Path 26",
    d: "M83.076,0l-48.9,48.9L82.8,97.528H48.166L0,49.362,49.363,0Z",
    transform: "translate(1629.072 0.001)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevrons);
export default __webpack_public_path__ + "static/media/chevrons.3af25f50ec97a4d71a8d92d795984f39.svg";
export { ForwardRef as ReactComponent };